package co.maytes.standupbot.dashboard.components.widgets

import androidx.compose.runtime.Composable
import co.maytes.standupbot.dashboard.styles.Palette
import co.maytes.standupbot.dashboard.styles.Spacing
import co.maytes.standupbot.dashboard.styles.Typography
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.text.SpanText
import kotlinx.browser.window

data class BackBarJump(val label: String, val path: String, val icon: String = "↗")

@Composable
fun BackBar(
    fallbackPath: String,
    jumpTo: BackBarJump? = null,
) {
    val ctx = rememberPageContext()
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .margin(bottom = Spacing.md),
        horizontalArrangement = Arrangement.spacedBy(Spacing.xs),
        verticalAlignment = Alignment.CenterVertically,
    ) {
        Button(
            label = "← Back",
            variant = ButtonVariant.Ghost,
            size = ButtonSize.Sm,
            onClick = {
                if (window.history.length > 1) {
                    window.history.back()
                } else {
                    ctx.router.navigateTo(fallbackPath)
                }
            },
        )
        if (jumpTo != null) {
            SpanText(
                text = "·",
                modifier = Modifier
                    .fontSize(Typography.bodySmall.size)
                    .color(Palette.textTertiary),
            )
            Button(
                label = "${jumpTo.icon} ${jumpTo.label}",
                variant = ButtonVariant.Ghost,
                size = ButtonSize.Sm,
                onClick = { ctx.router.navigateTo(jumpTo.path) },
            )
        }
    }
}
